<template>
  <div id="chartContainer">
    <VueApexCharts
      ref="apexPieChart"
      type="pie"
      :height="330 + this.heightOfTitle"
      :series="series"
      :options="options"
    />
    <br />
    <div v-if="this.resultatQueston.element_type === 'notation'" align="center">
      <star-rating
        style="display:inline-block; font-size:12px;"
        inactive-color="#4c514c"
        v-bind:star-size="18"
        :rating="calculMoyenne(this.resultatQueston.donneesPourcentage)"
        :rounded-corners="false"
        :show-rating="true"
        :read-only="true"
        :round-start-rating="false"
        :fixed-points="2"
      ></star-rating>
    </div>
    <div style="margin-top:-10px; text-align:center; ">
    <button
      class="button is-primary"
      @click="showModalAutre()"
      v-if="this.resultatQueston.autre === 1"
      >{{ $t("question.autre.details") }}</button
    ></div>
    <b-modal :width="620" :active.sync="showAutres">
      <PopupAutresResultats
        :questionId="questionId"
        :titre="resultatQueston.intitule"
      />
    </b-modal>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StarRating from 'vue-star-rating'
import PopupAutresResultats from '@/components/resultats/PopupAutresResultats'
import { mapGetters } from 'vuex'

export default {
  name: 'PieChart',
  components: {
    VueApexCharts,
    StarRating,
    PopupAutresResultats
  },
  data () {
    return {
      showAutres: false,
      height: 350,
      options: {
        labels: [],
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: true
            }
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        colors: [
          '#619fca',
          '#ffa555',
          '#c6d7ef',
          '#ffb2b0',
          '#af8dcd',
          '#d3c4df',
          '#a98078',
          '#d3b5af',
          '#ea99d1',
          '#9a9a9a',
          '#d5d5d5',
          '#cdcd59',
          '#e4e4a9',
          '#51cedb',
          '#5799c7',
          '#c2d5ee',
          '#ff9f4a',
          '#ffcc9a',
          '#b2e7a7'
        ],
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '8px',
          fontFamily: 'Helvetica, Arial',
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: 90,
          tooltipHoverFormatter: undefined,
          offsetX: 0,
          offsetY: 0,
          labels: {
            position: 'bottom',
            useSeriesColors: false
          },
          itemMargin: {
            horizontal: 10,
            vertical: 0
          }
        },
        markers: {
          width: 15,
          height: 15,
          strokeWidth: 1,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 1,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
        tooltip: {
          enabled: true,
          y: {
            show: true,
            formatter (val) {
              return val + '%'
            }
          }
        },
        noData: {
          text: this.$i18n.t('admin.nodataToshow'),
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: 'grey',
            fontSize: '18px'
          }
        }
      }
    }
  },
  computed: {
    languageQuestionAdmin () {
      return this.$store.getters.languageQuestionAdmin
    },
    series: function () {
      let totalReponse = 0
      this.resultatQueston.donneesPourcentage.resultats.forEach(nbResultats => {
        totalReponse += nbResultats
      })
      if (totalReponse > 0) {
        return this.resultatQueston.donneesPourcentage.resultats
      } else {
        return []
      }
    },
    widthSvg: function () {
      return parseInt(
        document.querySelector('.apexcharts-svg').attributes.width.value
      )
    },
    heightOfTitle: function () {
      return (
        this.titleIntoArray(
          this.resultatQueston.intitule,
          Math.round(window.innerWidth * 0.8)
        ).length * 4
      )
    },
    ...mapGetters(['sondage_vue_resultats', 'sondage_data_resultats', 'languageQuestionAdmin'])
  },
  watch: {
    sondage_data_resultats () {
      this.createComponentFunction()
    },
    languageQuestionAdmin: function (val) {
      if (val) {
        this.createComponentFunction()
      }
    }
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    showModalAutre () {
      this.sendMessageToParent('scrollToTop')
      this.showAutres = !this.showAutres
    },
    calculMoyenne (donnees) {
      var moyenne = 0
      var sommes = 0
      // initialisation du tableau
      let array = [1, 2, 3, 4, 5]
      for (let index = 0; index < array.length; index++) {
        moyenne += array[index] * donnees.resultats[index]
        sommes += donnees.resultats[index]
      }
      if (sommes !== 0) {
        return moyenne / sommes
      } else {
        return sommes
      }
    },
    titleIntoArray (text, width) {
      let arrayGlobal = []
      let arrayFinal = ['']
      let array = text.split(' ')
      const ratio = 3
      let tailleParLigne = Math.round(width / ratio)
      array.forEach(element1 => {
        arrayGlobal.push([element1, element1.length])
      })
      let i = 0
      let nbLigne = 0
      arrayGlobal.forEach((element, index) => {
        if ((i += arrayGlobal[index][1] + 1) < tailleParLigne) {
          i += arrayGlobal[index][1] + 1
          arrayFinal[nbLigne] += element[0] + ' '
        } else {
          nbLigne += 1
          i = 0
          arrayFinal[nbLigne] = '' + element[0] + ' '
        }
      })
      return arrayFinal
    },
    createComponentFunction () {
      // translate the entitled element (question)
      let translationArrayAnswers = []
      let translationQuestion = ''
      switch (this.$store.getters.languageQuestionAdmin) {
        case 'fr':
          // question
          translationQuestion = this.resultatQueston.intitule
          // answers
          translationArrayAnswers = this.resultatQueston.donneesPourcentage.noms
          translationArrayAnswers.forEach((answer, index) => {
            if (answer === null) {
              translationArrayAnswers[index] = 'Autre'
            }
          })
          break
        case 'en':
          // question
          translationQuestion = this.resultatQueston.intitule_en
          // answers
          if (this.resultatQueston.donneesPourcentage.noms_en !== undefined) {
            translationArrayAnswers = this.resultatQueston.donneesPourcentage.noms_en
          } else {
            // add new value answers if 'notation' type and language is 'en'
            translationArrayAnswers = [1, 2, 3, 4, 5]
          }
          translationArrayAnswers.forEach((answer, index) => {
            if (answer === null) {
              translationArrayAnswers[index] = 'Other'
            }
          })
          break
        case 'es':
          // question
          translationQuestion = this.resultatQueston.intitule_es
          // answers
          if (this.resultatQueston.donneesPourcentage.noms_es !== undefined) {
            translationArrayAnswers = this.resultatQueston.donneesPourcentage.noms_es
          } else {
            // add new value answers if 'notation' answer type and language is 'es'
            translationArrayAnswers = [1, 2, 3, 4, 5]
          }
          translationArrayAnswers.forEach((answer, index) => {
            if (answer === null) {
              translationArrayAnswers[index] = 'Otro'
            }
          })
          break
        case 'de':
          // question
          translationQuestion = this.resultatQueston.intitule_de
          // answers
          if (this.resultatQueston.donneesPourcentage.noms_de !== undefined) {
            translationArrayAnswers = this.resultatQueston.donneesPourcentage.noms_de
          } else {
            // add new value answers if 'notation' answer type and language is 'es'
            translationArrayAnswers = [1, 2, 3, 4, 5]
          }
          translationArrayAnswers.forEach((answer, index) => {
            if (answer === null) {
              translationArrayAnswers[index] = 'Otro'
            }
          })
          break
      }
      this.options = {
        legend: {
          position: 'bottom'
        },
        title: {
          text: this.titleIntoArray(
            translationQuestion,
            Math.round(window.innerWidth * 0.8)
          ),
          align: 'center',
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#263238'
          }
        },
        labels: translationArrayAnswers.map(
          nom => {
            if (toString(nom).length > 0 && nom !== '') {
              return nom
            } else {
              return 'autre'
            }
          })
      }
      /* this.options.labels = translationArrayAnswers.map(
        nom => {
          if (toString(nom).length > 0 && nom !== '') {
            return nom
          } else {
            return 'autre'
          }
        }
      ) */
    }
  },
  props: ['resultatQueston', 'questionId'],
  mounted () {
    this.createComponentFunction()
    if (this.sondage_vue_resultats === 'slider') {
      this.$store.commit('UNSET_CHARTS_REFS')
      this.$store.commit('SET_PIE_CHARTS_REFS', this.$refs.apexPieChart)
    } else if (this.sondage_vue_resultats === 'all') {
      this.$store.commit('SET_PIE_CHARTS_REFS', this.$refs.apexPieChart)
    }

    if (this.resultatQueston.file_url !== undefined) {
      // this.$refs.apexPieChart.addImage({
      //   path: this.resultatQueston.file_url,
      //   height: 150
      // })
    }
  }
}
</script>

<style scoped>
.titrePerso {
  word-wrap: break-word;
}

#chartContainer {
  margin: 10px;
}
.button {
  border-radius: 0px;
  font-size: 12px;
  border-radius:4px;
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/charts/PieChart.vue